import { Component, Input, OnInit } from '@angular/core';
import { AliadoSucursal } from '../../_models/aliado-sucursal';
import { AliadoSucursalCupo } from '../../_models/aliado-sucursal-cupo';
import { AliadoSucursalCupoService } from '../../_services/aliado-sucursal-cupo.service';
import { NavService } from '../../_services/_nav.service';
import moment from 'moment';
import 'moment/locale/es';
import { AliadoSucursalService } from '../../_services/aliado-sucursal.service';
import { CalendarioPropiedades } from '../../_models/calendario-propiedades';

@Component( {
  selector: 'app-aliados-sucursales-cupos',
  templateUrl: './aliados-sucursales-cupos.component.html',
  styles: []
} )
export class AliadosSucursalesCuposComponent implements OnInit {

  @Input() sucursal: AliadoSucursal;
  listadoAliadosSucursalesCupos: AliadoSucursalCupo[] = [];
  listadoAliadosSucursalesCuposTemp: AliadoSucursalCupo[] = [];
  columnas: any = [];
  carTabla = false;
  es: any;
  fechas: Date[];
  calendarProperties: CalendarioPropiedades = new CalendarioPropiedades();

  constructor( private navServicio: NavService,
               private aliadoSucursalCupoService: AliadoSucursalCupoService,
               private aliadoSucursalService: AliadoSucursalService ) {
  }

  ngOnInit() {
    this.calendarProperties.actualizarRango( 10 );

    this.columnas = [
      { field: 'fechaInicio', header: this.navServicio.buscarMensaje( 'ALIADOSUCURSALCUPO.LBL_FECHAINICIO' ), sort: true },
      { field: 'fechaFin', header: this.navServicio.buscarMensaje( 'ALIADOSUCURSALCUPO.LBL_FECHAFIN' ), sort: true },
      { field: 'cupoValor', header: this.navServicio.buscarMensaje( 'ALIADOSUCURSALCUPO.LBL_CUPOVALOR' ), sort: true },
      { field: 'cupoCreditos', header: this.navServicio.buscarMensaje( 'ALIADOSUCURSALCUPO.LBL_CUPONCREDITOS' ), sort: true },
      { field: 'cupoValorConsumido', header: this.navServicio.buscarMensaje( 'ALIADOSUCURSALCUPO.LBL_CUPOVALORCONSUMIDO' ), sort: true },
      {
        field: 'cupoCreditosConsumidos',
        header: this.navServicio.buscarMensaje( 'ALIADOSUCURSALCUPO.LBL_CUPOCREDITOSCONSUMIDO' ),
        sort: true
      }
    ];
    const data = { 'fechaInicio': null, 'fechaFin': null };
    data.fechaInicio = moment().add( 'year', - 1 ).format( 'YYYY-MM-DD' );
    data.fechaFin = moment().format( 'YYYY-MM-DD' );
    this.cargarTabla( data );
  }

  cargarTabla( data ) {
    this.carTabla = true;
    this.aliadoSucursalService.obtenerPorAliadoSucursalPost( this.sucursal.idAliadoSucursal, data ).subscribe( res => {
      this.listadoAliadosSucursalesCupos = res;
      this.listadoAliadosSucursalesCuposTemp = Object.assign( [], res );
      this.carTabla = false;
    } );
  }

  filtroFechas() {
    const lista = [];
    if ( this.fechas[ 0 ] !== null && this.fechas[ 1 ] !== null ) {
      const inicio = moment( this.fechas[ 0 ] );
      const fin = moment( this.fechas[ 1 ] );
      const data = { 'fechaInicio': null, 'fechaFin': null };
      data.fechaInicio = inicio.format( 'YYYY-MM-DD' );
      data.fechaFin = fin.format( 'YYYY-MM-DD' );
      this.cargarTabla( data );
      // this.listadoAliadosSucursalesCuposTemp.map( x => {
      //   if ( moment( new Date( x.fechaInicio ) ).isBetween( inicio, fin ) ) {
      //     lista.push( x );
      //   }
      // } );
      // this.listadoAliadosSucursalesCupos = lista;
    }
  }

  limpiarFiltroFechas() {
    // this.listadoAliadosSucursalesCupos = this.listadoAliadosSucursalesCuposTemp;
    const data = { 'fechaInicio': null, 'fechaFin': null };
    data.fechaInicio = moment().add( 'year', - 1 ).format( 'YYYY-MM-DD' );
    data.fechaFin = moment().format( 'YYYY-MM-DD' );
    this.cargarTabla( data );
  }


}
